import httpClient from "@/services/HttpService";

export default {

    sendMail: (content) => {
        return httpClient.post('/mail/send', content);
    }

}
